import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import EditDischargeReasonsForm from '@/components/EpisodeOfCareSection/components/DischargeReasons/components/EditDischargeReasonsForm';
import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';
import DataRow from '@/ui/components/DataList/DataRow';

import { Props } from './types';

const DischargeReasons = ({ dischargeReasons, episodeOfCareId, personId }: Props) => {
  const [editing, setEditing] = useState(false);

  return editing ? (
    <>
      <EditDischargeReasonsForm
        dischargeReasons={dischargeReasons}
        episodeOfCareId={episodeOfCareId}
        onSuccess={() => setEditing(false)}
        personId={personId}
      />

      <Button color={Color.WHITE} onClick={() => setEditing(false)} type="button">
        Cancel
      </Button>
    </>
  ) : (
    <div className="relative">
      <Button
        ariaLabel="Edit Discharge Reasons"
        className="absolute top-5 right-0 group-hover/section:visible invisible"
        color={Color.WHITE}
        onClick={() => setEditing(true)}
        size="xs"
        type="button">
        <FontAwesomeIcon icon={faPencil} />
      </Button>

      <DataRow label="Discharge Reasons">
        {dischargeReasons?.map((reason, index) => {
          return <div key={`${reason}-${index}`}>{reason}</div>;
        })}
      </DataRow>
    </div>
  );
};

export default DischargeReasons;
